import licenseModule from '../../license.module';
import template from './licenseOverviewDevice.component.html';
import style from './licenseOverviewDevice.component.css';

export default licenseModule.component('licenseOverviewDevice', {
    template,
    style,
    controller: licenseOverviewDeviceComponent,
    bindToController: true,
    bindings: {
        appspaceIdSummary: '<'
    }
});
function licenseOverviewDeviceComponent() {
    var vm = this;
    vm.$onChanges = render;
    vm.elements = [];

    function render(changeObj) {
        if (
            changeObj.appspaceIdSummary.currentValue &&
            changeObj.appspaceIdSummary.currentValue != null
        ) {
            vm.licenseOverviewDeviceUsages =
                vm.appspaceIdSummary.deviceLicenseTypes;
        }
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-overview-device/licenseOverviewDevice.component.js